angular.module('ui.login.loginShadow', [])

    .directive('loginShadow', function () {
        return {
            restrict: "E",
            templateUrl: "app/ui/login/loginShadow/loginShadow.html",
            controller: "LoginShadowController",
            scope: {}
        };
    })

    .controller('LoginShadowController', function LoginController($scope, $state, $element, toastr, authService, loginShadowService) {
        $scope.isBusy = false;
        $scope.credentials = {};

        $scope.credentials.login = authService.getLastUsername();

        $scope.onOpen = function () {

            var kwindow = $("#loginShadowWindow").data("kendoWindow");
            kwindow.center();
            kwindow.setOptions({
                position: {
                    top: '15%',
                    left: kwindow.options.position.left
                },
                animation: om.config.kendoWindowDefaultOptions.animation
            });
            $("#password").focus();
        };

        $scope.onClose = function () {

        };

        $scope.onActivate = function () {

        };

        $scope.anotherUser = function () {
            $("#loginShadowWindow").data("kendoWindow").destroy();
            loginShadowService.close();
            authService.clearAuthentication();
            $state.go('login');
        };

        $scope.login = function () {
            $scope.credentials.login = authService.getLastUsername();
            $scope.isBusy = true;
            $scope.$broadcast("autofill:update");

            authService.login(authService.getLastUsername(), $scope.credentials.password).then(
                function () {
                    $scope.isBusy = false;
                    $("#loginShadowWindow").data("kendoWindow").destroy();
                    loginShadowService.close();
                },
                function (resp) {
                    var data = resp.data;
                    $scope.isBusy = false;
                    var msg;
                    if (data && data.error && _.isString(data.error)) {
                        msg = data.error;
                    } else if (data && _.isString(data) && data.length > 0 && data.length < 256) {
                        msg = data;
                    } else {
                        msg = "Wrong username or password. Please try again.";
                    }
                    toastr.error(msg, "Login failed");
                }
            );

            return false;
        };
    })

;
